module.exports = "/React/dist/3ced368e2a9f7cd583420f6baa104934.png";